import { ComponentType } from 'react'

import { ReactComponent as DeadlineIcon } from '@app/assets/Small/Outline/Deadline.svg'
import { ReactComponent as FileTextIcon } from '@app/assets/Small/Outline/FileText.svg'
import { ReactComponent as GavelIcon } from '@app/assets/Small/Outline/Gavel.svg'
import { ReactComponent as GavelAbort } from '@app/assets/Small/Outline/GavelAbort.svg'
import { ReactComponent as GavelClosedIcon } from '@app/assets/Small/Outline/GavelClosed.svg'
import { ReactComponent as GavelTimeIcon } from '@app/assets/Small/Outline/GavelTime.svg'
import { ReactComponent as PhoneCallIcon } from '@app/assets/Small/Outline/PhoneCall.svg'
import { CourtCaseEventType } from '@app/graphql/types'
import { IconBadgeProps } from '@app/lib/display/IconBadge/IconBadge'

type EventSettings = Record<
  CourtCaseEventType,
  {
    iconColor: IconBadgeProps['color']
    icon: ComponentType
  }
>

export const EVENT_SETTINGS: EventSettings = {
  [CourtCaseEventType.Aborted]: {
    iconColor: 'danger',
    icon: GavelAbort
  },
  [CourtCaseEventType.CourtCaseStarted]: {
    iconColor: 'neutral',
    icon: GavelIcon
  },
  [CourtCaseEventType.ClientFileApproved]: {
    iconColor: 'neutral',
    icon: FileTextIcon
  },
  [CourtCaseEventType.CourtSession]: {
    iconColor: 'danger',
    icon: GavelTimeIcon
  },
  [CourtCaseEventType.Deadline]: {
    iconColor: 'danger',
    icon: DeadlineIcon
  },
  [CourtCaseEventType.CourtCaseClosed]: {
    iconColor: 'success',
    icon: GavelClosedIcon
  },
  [CourtCaseEventType.CourtCaseReopened]: {
    iconColor: 'neutral',
    icon: GavelIcon
  },
  [CourtCaseEventType.Appointment]: {
    iconColor: 'info',
    icon: PhoneCallIcon
  }
}
